import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.character');
import { OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-character',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.character/view.scss */
:host {
  display: none;
}`],
})
export class ComponentCharacterComponent implements OnInit {
    @Input() blockInput: boolean = false;

    @Output() keysChange = new EventEmitter<{ [key: string]: boolean }>();
    @Output() jumpTriggered = new EventEmitter<void>();

    private keys: { [key: string]: boolean } = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    // ===== Keyboard Input =====

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const target = event.target as HTMLElement;
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return;
        if (this.blockInput) return;

        const key = this.normalizeKey(event.key);
        if (key) {
            event.preventDefault();
            this.keys[key] = true;
            this.keysChange.emit({ ...this.keys });
            return;
        }

        if (event.key === ' ' || event.code === 'Space') {
            event.preventDefault();
            this.jumpTriggered.emit();
            return;
        }
    }

    @HostListener('window:keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {
        const key = this.normalizeKey(event.key);
        if (key) {
            this.keys[key] = false;
            this.keysChange.emit({ ...this.keys });
            const target = event.target as HTMLElement;
            if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') event.preventDefault();
        }
    }

    @HostListener('window:blur')
    onWindowBlur() {
        this.keys = {};
        this.keysChange.emit({});
    }

    // ===== Joystick =====

    public onJoystickDirection(keys: { [key: string]: boolean }) {
        this.keys = keys;
        this.keysChange.emit({ ...keys });
    }

    // ===== Helpers =====

    private normalizeKey(key: string): string | null {
        const keyMap: { [k: string]: string } = {
            'w': 'up', 'W': 'up', 'ㅈ': 'up',
            'a': 'left', 'A': 'left', 'ㅁ': 'left',
            's': 'down', 'S': 'down', 'ㄴ': 'down',
            'd': 'right', 'D': 'right', 'ㅇ': 'right',
            'ArrowUp': 'up', 'ArrowDown': 'down',
            'ArrowLeft': 'left', 'ArrowRight': 'right',
        };
        return keyMap[key] || null;
    }
}

export default ComponentCharacterComponent;